import { all, call, fork, put, take, takeEvery, actionChannel } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { buffers, SagaIterator } from 'redux-saga'
import { Action } from 'typescript-fsa'
import {
  CalendarApi,
  FacebookPageApi,
  InstagramPageApi,
  PageSettingsApi,
  PostTemplateApi,
  AboTopicsApi,
  AboSettingsApi,
  PostApi, DeferredPostApi,
  FacebookPostApi,
  InstagramPostApi, UserQuizRestServiceApi, UserHasPageApi, LinkedInPageApi, UrlInformationExtractorApi,
} from '../../api/instances'
import {
  deletePostTemplate,
  deletePostTemplateInitiated,
  findGlobalPostsForPostTemplate,
  findGlobalPostsForPostTemplateInitiated,
  findPostTemplatesForCurrentUser,
  findPostTemplatesForCurrentUserInitiated,
  getCalendarDataInitiated,
  getAboSettingsForCurrentUser,
  getFacebookPost,
  getFacebookPostInitiated,
  getAboSettingsForCurrentUserInitiated,
  getCalendarData,
  getIgPage,
  getIgPageInitiated,
  getTopicsAndMetadataForCurrentUser,
  getTopicsAndMetadataForCurrentUserInitiated,
  loadFacebookPage,
  loadFacebookPageInitiated,
  updateAboSettingsForCurrentUser,
  updateAboSettingsForCurrentUserInitiated,
  updateCorePageSettings,
  updateCorePageSettingsInitiated,
  updatePostTemplate,
  updatePostTemplateInitiated,
  publishPostInitiated,
  publishPost,
  declineManualDeferredPost,
  declineManualDeferredPostInitiated,
  getCoreInstaPageSettings,
  getCoreInstaPageSettingsInitiated,
  getCoreFBPageSettingsInitiated,
  getCoreFBPageSettings,
  getInstagramPostInitiated,
  getInstagramPost,
  getMultipleChoiceQuizInitiated,
  getMultipleChoiceQuiz,
  getSelectedMultipleChoiceQuizInitiated,
  getSelectedMultipleChoiceQuiz,
  deleteManualDeferredPost,
  deleteManualDeferredPostInitiated,
  confirmManualDeferredPostInitiated,
  confirmManualDeferredPost,
  deletePost,
  deletePostInitiated,
  retryManualDeferredPost,
  retryManualDeferredPostInitiated,
  getPageMaster,
  getPageMasterInitiated,
  listPageOwnersForPage,
  listPageOwnersForPageInitiated,
  setUserAsPageMasterInitiated,
  setUserAsPageMaster, getLinkedInPageInitiated, getLinkedInPage, getUrlInformation, getUrlInformationInitiated,
} from './dashboard.actions'
import { GetFacebookPageRequest } from '@3m5/sm_publish-frontend-api/apis/FacebookPageApi'
import { GetInstagramPageRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPageApi'
import { GetCalendarDataRequest } from '@3m5/sm_publish-frontend-api/apis/CalendarApi'

import { FindPostTemplatesForCurrentUserLightweightRequest, GetFacebookPostRequest, UpdateAboSettingsForCurrentUserRequest, UpdateCorePageSettingsRequest, GetCorePageSettingsRequest, GetUrlInformationRequest } from '@3m5/sm_publish-frontend-api'
import { DeletePostTemplateRequest, FindGlobalPostsForPostTemplateRequest, UpdatePostTemplateRequest } from '@3m5/sm_publish-frontend-api/apis/PostTemplateApi'
import i18n from 'i18next'
import { EventType, Severity } from '@professocial/professocialTypes/types'
import {
  requestFailed,
  requestFinished,
  requestStarted,
  setMessage
} from '../common/common.actions'
import { DeletePostRequest, PublishPostRequest } from '@3m5/sm_publish-frontend-api/apis/PostApi'
import {
  ConfirmManualDeferredPostRequest,
  DeclineManualDeferredPostRequest,
  DeleteManualDeferredPostRequest, RetryManualDeferredPostRequest,
} from '@3m5/sm_publish-frontend-api/apis/DeferredPostApi'
import { GetInstagramPostRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPostApi'
import { GetMultipleChoiceQuizRequest } from '@professocialApi/professocial-core-frontend-api/apis/UserQuizRestServiceApi'
import { GetPageMasterRequest } from '@professocialApi/professocial-core-frontend-api'
import {
  ListPageOwnersForPageRequest,
  SetUserAsPageMasterRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/UserHasPageApi'
import { GetLinkedInPageRequest } from '@3m5/sm_publish-frontend-api/apis/LinkedInPageApi'

// loadFacebookPage
const loadFacebookPageWorker = bindAsyncAction(loadFacebookPage)(
  function * (params: GetFacebookPageRequest) {
    return yield call([FacebookPageApi, FacebookPageApi.getFacebookPage], params)
  },
)

function * watchLoadFacebookPageInitiated () {
  while (true) {
    const action: Action<GetFacebookPageRequest> = yield take(loadFacebookPageInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield loadFacebookPageWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchUpdateUserDataInitiated: ', e)
    }
  }
}

// getIgPage
const getIgPageWorker = bindAsyncAction(getIgPage)(
  function * (params: GetInstagramPageRequest) {
    return yield call([InstagramPageApi, InstagramPageApi.getInstagramPage], params)
  },
)

function * watchGetIgPageInitiated () {
  while (true) {
    const action: Action<GetInstagramPageRequest> = yield take(getIgPageInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield getIgPageWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchGetIgPageInitiated: ', e)
    }
  }
}

// getIgPage
const getLinkedInPageWorker = bindAsyncAction(getLinkedInPage)(
  function * (params: GetLinkedInPageRequest) {
    return yield call([LinkedInPageApi, LinkedInPageApi.getLinkedInPage], params)
  },
)

function * watchGetLinkedInPageInitiated () {
  while (true) {
    const action: Action<GetLinkedInPageRequest> = yield take(getLinkedInPageInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield getLinkedInPageWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchGetLinkedInPageInitiated: ', e)
    }
  }
}

// getCalendarData
const getCalendarDataWorker = bindAsyncAction(getCalendarData)(
  function * (params: GetCalendarDataRequest) {
    return yield call([CalendarApi, CalendarApi.getCalendarData], params)
  },
)

function * watchGetCalendarDataInitiated () {
  while (true) {
    const action: Action<GetCalendarDataRequest> = yield take(getCalendarDataInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield getCalendarDataWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchGetCalendarDataInitiated: ', e)
    }
  }
}
// getTopicsAndMetadataForCurrentUser
const getTopicsAndMetadataForCurrentUserWorker = bindAsyncAction(getTopicsAndMetadataForCurrentUser)(
  function * () {
    return yield call([AboTopicsApi, AboTopicsApi.getTopicsAndMetadataForCurrentUser])
  },
)

function * watchGetTopicsAndMetadataForCurrentUserInitiated () {
  while (true) {
    const action: Action<undefined> = yield take(getTopicsAndMetadataForCurrentUserInitiated)
    try {
      yield getTopicsAndMetadataForCurrentUserWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetTopicsAndMetadataForCurrentUserInitiated: ', e)
    }
  }
}

/*
 *  Post Templates
 */

// findPostTemplatesForCurrentUser
const findPostTemplatesForCurrentUserWorker = bindAsyncAction(findPostTemplatesForCurrentUser)(
  function * (params: FindPostTemplatesForCurrentUserLightweightRequest) {
    return yield call([PostTemplateApi, PostTemplateApi.findPostTemplatesForCurrentUserLightweight], params)
  },
)

function * watchFindPostTemplatesForCurrentUserInitiated () {
  while (true) {
    const action: Action<FindPostTemplatesForCurrentUserLightweightRequest> = yield take(findPostTemplatesForCurrentUserInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield findPostTemplatesForCurrentUserWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchFindPostTemplatesForCurrentUserInitiated: ', e)
    }
  }
}

// deletePostTemplate
const deletePostTemplateWorker = bindAsyncAction(deletePostTemplate)(
  function * (params: DeletePostTemplateRequest) {
    return yield call([PostTemplateApi, PostTemplateApi.deletePostTemplate], params)
  },
)

function * watchDeletePostTemplateInitiated () {
  while (true) {
    const action: Action<DeletePostTemplateRequest> = yield take(deletePostTemplateInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield deletePostTemplateWorker(action.payload)
      yield put(setMessage({
        severity: Severity.success,
        message: i18n.t('coreMessages:isSuccessfullyDeleted', { context: i18n.t('facebookSettingsCommon:template') }),
        eventType: EventType.delete,
      }))
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: i18n.t('coreMessages:deleteError', { context: i18n.t('facebookSettingsCommon:template') }),
        eventType: EventType.update,
      }))
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchDeletePostTemplateInitiated: ', e)
    }
  }
}

// updateCorePageSettings
const updateCorePageSettingsWorker = bindAsyncAction(updateCorePageSettings)(
  function * (params: UpdateCorePageSettingsRequest) {
    return yield call([PageSettingsApi, PageSettingsApi.updateCorePageSettings], params)
  },
)

function * UpdateCorePageSettingsInitiated () {
  while (true) {
    const action: Action<UpdateCorePageSettingsRequest> = yield take(updateCorePageSettingsInitiated)
    try {
      yield updateCorePageSettingsWorker(action.payload)
      yield put(setMessage({
        severity: Severity.success,
        message: i18n.t('coreMessages:isSuccessfullyUpdated', { context: i18n.t('topicsCommon:aboEmailShort') }),
        eventType: EventType.update,
      }))
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: i18n.t('coreMessages:updateError', { context: i18n.t('topicsCommon:aboEmailShort') }),
        eventType: EventType.update,
      }))
    }
  }
}

// updateAboSettingsForCurrentUser
const updateAboSettingsForCurrentUserWorker = bindAsyncAction(updateAboSettingsForCurrentUser)(
  function * (params: UpdateAboSettingsForCurrentUserRequest) {
    return yield call([AboSettingsApi, AboSettingsApi.updateAboSettingsForCurrentUser], params)
  },
)

function * watchUpdateAboSettingsForCurrentUserInitiated () {
  while (true) {
    const action: Action<UpdateAboSettingsForCurrentUserRequest> = yield take(updateAboSettingsForCurrentUserInitiated)
    try {
      yield updateAboSettingsForCurrentUserWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:updateAboSettingsForCurrentUserError',
        eventType: EventType.update,
      }))
      console.error('error in watchUpdateAboSettingsForCurrentUserInitiated: ', e)
    }
  }
}

// updatePostTemplate
const updatePostTemplateWorker = bindAsyncAction(updatePostTemplate)(
  function * (params: UpdatePostTemplateRequest) {
    return yield call([PostTemplateApi, PostTemplateApi.updatePostTemplate], params)
  },
)

function * watchUpdatePostTemplateInitiated () {
  while (true) {
    const action: Action<UpdatePostTemplateRequest> = yield take(updatePostTemplateInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield updatePostTemplateWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyUpdated',
            { context: i18n.t('facebookSettingsCommon:template') }),
          eventType: EventType.update,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:updateError',
            { context: i18n.t('facebookSettingsCommon:template') }),
          eventType: EventType.update,
        },
      }))
      console.error('error in watchupdatePostTemplateInitiated: ', e)
    }
  }
}

// findGlobalPostsForPostTemplate
const findGlobalPostsForPostTemplateWorker = bindAsyncAction(findGlobalPostsForPostTemplate)(
  function * (params: FindGlobalPostsForPostTemplateRequest) {
    return yield call([PostTemplateApi, PostTemplateApi.findGlobalPostsForPostTemplate], params)
  },
)

function * watchFindGlobalPostsForPostTemplateInitiated () {
  while (true) {
    const action: Action<FindGlobalPostsForPostTemplateRequest> = yield take(findGlobalPostsForPostTemplateInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield findGlobalPostsForPostTemplateWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:loadingError',
            { context: i18n.t('facebookSettingsCommon:template') }),
          eventType: EventType.load,
        },
      }))
      console.error('error in watchFindGlobalPostsForPostTemplateInitiated: ', e)
    }
  }
}

// getFacebookPost
const getFacebookPostWorker = bindAsyncAction(getFacebookPost)(
  function * (params: GetFacebookPostRequest) {
    return yield call([FacebookPostApi, FacebookPostApi.getFacebookPost], params)
  },
)

function * watchGetFacebookPostInitiated () {
  yield takeEvery(getFacebookPostInitiated, function * (action: Action<GetFacebookPostRequest>) {
    yield put(requestStarted({ type: action.type, id: action.payload.networkPostId }))
    try {
      yield getFacebookPostWorker(action.payload)
      yield put(requestFinished({ type: action.type, id: action.payload.networkPostId }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        id: action.payload.networkPostId,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:loadingError', { context: i18n.t('coreDashboard:instagramPost') }),
          eventType: EventType.load,
        },
      }))
      console.error('error in watchGetFacebookPostInitiated: ', e)
    }
  })
}

// getInstagramPost
const getInstagramPostWorker = bindAsyncAction(getInstagramPost)(
  function * (params: GetInstagramPostRequest) {
    return yield call([InstagramPostApi, InstagramPostApi.getInstagramPost], params)
  },
)

function * watchGetInstagramPostInitiated () {
  yield takeEvery(getInstagramPostInitiated, function * (action: Action<GetInstagramPostRequest>) {
    yield put(requestStarted({ type: action.type, id: action.payload.networkPostId }))
    try {
      yield getInstagramPostWorker(action.payload)
      yield put(requestFinished({ type: action.type, id: action.payload.networkPostId }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        id: action.payload.networkPostId,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:loadingError', { context: i18n.t('coreDashboard:instagramPost') }),
          eventType: EventType.load,
        },
      }))
      console.error('error in watchGetInstagramPostInitiated: ', e)
    }
  })
}

// getAboSettingsForCurrentUser
const getAboSettingsForCurrentUserWorker = bindAsyncAction(getAboSettingsForCurrentUser)(
  function * () {
    return yield call([AboSettingsApi, AboSettingsApi.getAboSettingsForCurrentUser])
  },
)

function * watchGetAboSettingsForCurrentUserInitiated () {
  while (true) {
    const action: Action<undefined> = yield take(getAboSettingsForCurrentUserInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield getAboSettingsForCurrentUserWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetAboSettingsForCurrentUserInitiated: ', e)
    }
  }
}

// publishPost
const publishPostWorker = bindAsyncAction(publishPost)(
  function * (params: PublishPostRequest) {
    return yield call([PostApi, PostApi.publishPost], params)
  },
)

function * watchPublishPostInitiated () {
  while (true) {
    const action: Action<PublishPostRequest> = yield take(publishPostInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield publishPostWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
      }))
      window.dispatchEvent(new CustomEvent('ProfessocialMessage', {
        detail: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyUpdated',
            { context: i18n.t('facebookSettingsCommon:template') }),
          eventType: EventType.create,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:updateError',
            { context: i18n.t('facebookSettingsCommon:template') }),
          eventType: EventType.create,
        },
      }))
      console.error('error in watchPublishPostInitiated: ', e)
    }
  }
}

// deletePost
const deletePostWorker = bindAsyncAction(deletePost)(
  function * (params: DeletePostRequest) {
    return yield call([PostApi, PostApi.deletePost], params)
  },
)

function * watchDeletePostInitiated () {
  while (true) {
    const action: Action<DeletePostRequest> = yield take(deletePostInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield deletePostWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyDeleted',
            { context: 'Post' }),
          eventType: EventType.delete,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:deleteError',
            { context: 'Post' }),
          eventType: EventType.delete,
        },
      }))
      console.error('error in watchDeletePostInitiated: ', e)
    }
  }
}

// deleteManualDeferredPost
const deleteManualDeferredPostWorker = bindAsyncAction(deleteManualDeferredPost)(
  function * (params: DeleteManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.deleteManualDeferredPost], params)
  },
)

function * watchDeleteManualDeferredPostInitiated () {
  while (true) {
    const action: Action<DeleteManualDeferredPostRequest> = yield take(deleteManualDeferredPostInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield deleteManualDeferredPostWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
      }))
      window.dispatchEvent(new CustomEvent('ProfessocialMessage', {
        detail: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyDeleted',
            { context: 'Post' }),
          eventType: EventType.delete,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:deleteError',
            { context: 'Post' }),
          eventType: EventType.delete,
        },
      }))
      console.error('error in watchDeleteManualDeferredPostInitiated: ', e)
    }
  }
}

// confirmManualDeferredPost
const confirmManualDeferredPostWorker = bindAsyncAction(confirmManualDeferredPost)(
  function * (params: ConfirmManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.confirmManualDeferredPost], params)
  },
)

function * watchConfirmManualDeferredPostInitiated () {
  while (true) {
    const action: Action<ConfirmManualDeferredPostRequest> = yield take(confirmManualDeferredPostInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield confirmManualDeferredPostWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyUpdated',
            { context: 'Post' }),
          eventType: EventType.update,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:updateError',
            { context: 'Post' }),
          eventType: EventType.update,
        },
      }))
      console.error('error in watchConfirmManualDeferredPostInitiated: ', e)
    }
  }
}

// retryManualDeferredPost
const retryManualDeferredPostWorker = bindAsyncAction(retryManualDeferredPost)(
  function * (params: RetryManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.retryManualDeferredPost], params)
  },
)

function * watchRetryManualDeferredPostInitiated () {
  while (true) {
    const action: Action<RetryManualDeferredPostRequest> = yield take(retryManualDeferredPostInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield retryManualDeferredPostWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyPublished',
            { context: 'Post' }),
          eventType: EventType.create,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:publishError',
            { context: 'Post' }),
          eventType: EventType.create,
        },
      }))
      console.error('error in watchRetryManualDeferredPostInitiated: ', e)
    }
  }
}

// declineManualDeferredPost
const declineManualDeferredPostWorker = bindAsyncAction(declineManualDeferredPost)(
  function * (params: DeclineManualDeferredPostRequest) {
    return yield call([DeferredPostApi, DeferredPostApi.declineManualDeferredPost], params)
  },
)

function * watchDeclineManualDeferredPostInitiated () {
  while (true) {
    const action: Action<DeclineManualDeferredPostRequest> = yield take(declineManualDeferredPostInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield declineManualDeferredPostWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyDeleted',
            { context: 'Post' }),
          eventType: EventType.delete,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:deleteError',
            { context: 'Post' }),
          eventType: EventType.delete,
        },
      }))
      console.error('error in watchDeclineManualDeferredPostInitiated: ', e)
    }
  }
}

// getCoreFBPageSettings
const getCoreFBPageSettingsWorker = bindAsyncAction(getCoreFBPageSettings)(
  function * (params: GetCorePageSettingsRequest) {
    return yield call([PageSettingsApi, PageSettingsApi.getCorePageSettings], params)
  },
)

function * watchGetCoreFBPageSettingsInitiated () {
  while (true) {
    const action: Action<GetCorePageSettingsRequest> = yield take(getCoreFBPageSettingsInitiated)
    try {
      yield getCoreFBPageSettingsWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetCorePageSettingsInitiated: ', e)
    }
  }
}

// getCoreInstaPageSettings
const getCoreInstaPageSettingsWorker = bindAsyncAction(getCoreInstaPageSettings)(
  function * (params: GetCorePageSettingsRequest) {
    return yield call([PageSettingsApi, PageSettingsApi.getCorePageSettings], params)
  },
)

function * watchGetCoreInstaPageSettingsInitiated () {
  while (true) {
    const action: Action<GetCorePageSettingsRequest> = yield take(getCoreInstaPageSettingsInitiated)
    try {
      yield getCoreInstaPageSettingsWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetCoreInstaPageSettingsInitiated: ', e)
    }
  }
}

// getMultipleChoiceQuiz
const getMultipleChoiceQuizWorker = bindAsyncAction(getMultipleChoiceQuiz)(
  function * (params: GetMultipleChoiceQuizRequest) {
    return yield call([UserQuizRestServiceApi, UserQuizRestServiceApi.getMultipleChoiceQuiz], params)
  },
)

function * watchGetMultipleChoiceQuizInitiated () {
  while (true) {
    const action: Action<GetMultipleChoiceQuizRequest> = yield take(getMultipleChoiceQuizInitiated)
    try {
      yield getMultipleChoiceQuizWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetMultipleChoiceQuizInitiated: ', e)
    }
  }
}

// getSelectedMultipleChoiceQuiz
const getSelectedMultipleChoiceQuizWorker = bindAsyncAction(getSelectedMultipleChoiceQuiz)(
  function * () {
    return yield call([UserQuizRestServiceApi, UserQuizRestServiceApi.getSelectedMultipleChoiceQuiz])
  },
)

function * watchGetSelectedMultipleChoiceQuizInitiated () {
  while (true) {
    const action: Action<undefined> = yield take(getSelectedMultipleChoiceQuizInitiated)
    try {
      yield getSelectedMultipleChoiceQuizWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetSelectedMultipleChoiceQuizInitiated: ', e)
    }
  }
}

// getPageMaster
const getPageMasterWorker = bindAsyncAction(getPageMaster)(
  function * (params: GetPageMasterRequest) {
    return yield call([UserHasPageApi, UserHasPageApi.getPageMaster], params)
  },
)

function * watchGetPageMasterInitiated () {
  yield takeEvery(getPageMasterInitiated, function * (action) {
    yield put(requestStarted({ type: action.type }))
    try {
      yield getPageMasterWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchGetPageMasterInitiated: ', e)
    }
  })
}

// listPageOwnersForPage
const listPageOwnersForPageWorker = bindAsyncAction(listPageOwnersForPage)(
  function * (params: ListPageOwnersForPageRequest) {
    return yield call([UserHasPageApi, UserHasPageApi.listPageOwnersForPage], params)
  },
)

function * watchListPageOwnersForPageInitiated () {
  yield takeEvery(listPageOwnersForPageInitiated, function * (action) {
    yield put(requestStarted({ type: action.type }))
    try {
      yield listPageOwnersForPageWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchListPageOwnersForPageInitiated: ', e)
    }
  })
}

// setCurrentUserAsPageMaster
const setUserAsPageMasterWorker = bindAsyncAction(setUserAsPageMaster)(
  function * (params: SetUserAsPageMasterRequest) {
    return yield call([UserHasPageApi, UserHasPageApi.setUserAsPageMaster], params)
  },
)

function * watchSetUserAsPageMasterInitiated () {
  while (true) {
    const action: Action<SetUserAsPageMasterRequest> = yield take(setUserAsPageMasterInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield setUserAsPageMasterWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('coreMessages:isSuccessfullyUpdated', { context: i18n.t('coreSettings:siteOwner') }),
          eventType: EventType.update,
        },
      }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:deleteError', { context: i18n.t('coreSettings:siteOwner') }),
          eventType: EventType.delete,
        },
      }))
      console.error('error in watchSetUserAsPageMasterInitiated: ', e)
    }
  }
}

// getUrlInformation
const getUrlInformationWorker = bindAsyncAction(getUrlInformation)(
  function * (params: GetUrlInformationRequest): any {
    return yield call([UrlInformationExtractorApi, UrlInformationExtractorApi.getUrlInformation], params)
  },
)

function* watchGetUrlInformationInitiated(): SagaIterator {
  const requestChan = yield actionChannel(getUrlInformationInitiated, buffers.expanding(10))

  while (true) {
    const action: Action<{ data: GetUrlInformationRequest; id?: string }> = yield take(requestChan)
    yield put(requestStarted({ type: action.type, id: action.payload.id }))

    try {
      yield call(getUrlInformationWorker, action.payload.data)
      yield put(requestFinished({ type: action.type, id: action.payload.id }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        id: action.payload.id,
        error: e
      }))
      console.error('error in watchGetUrlInformationInitiated: ', e)
    }
  }
}

export function * dashboardSagas () {
  yield fork(watchLoadFacebookPageInitiated)
  yield fork(watchGetIgPageInitiated)
  yield fork(watchGetLinkedInPageInitiated)
  yield fork(watchGetCalendarDataInitiated)
  yield fork(watchFindPostTemplatesForCurrentUserInitiated)
  yield fork(watchDeletePostTemplateInitiated)
  yield fork(UpdateCorePageSettingsInitiated)
  yield fork(watchGetTopicsAndMetadataForCurrentUserInitiated)
  yield fork(watchGetAboSettingsForCurrentUserInitiated)
  yield fork(watchUpdateAboSettingsForCurrentUserInitiated)
  yield fork(watchUpdatePostTemplateInitiated)
  yield fork(watchFindGlobalPostsForPostTemplateInitiated)
  yield fork(watchPublishPostInitiated)
  yield fork(watchConfirmManualDeferredPostInitiated)
  yield fork(watchDeclineManualDeferredPostInitiated)
  yield fork(watchRetryManualDeferredPostInitiated)
  yield fork(watchDeletePostInitiated)
  yield fork(watchDeleteManualDeferredPostInitiated)
  yield fork(watchGetCoreFBPageSettingsInitiated)
  yield fork(watchGetCoreInstaPageSettingsInitiated)
  yield fork(watchGetMultipleChoiceQuizInitiated)
  yield fork(watchGetSelectedMultipleChoiceQuizInitiated)
  yield fork(watchGetPageMasterInitiated)
  yield fork(watchListPageOwnersForPageInitiated)
  yield fork(watchSetUserAsPageMasterInitiated)
  yield all([
    watchGetFacebookPostInitiated(),
    watchGetInstagramPostInitiated(),
    watchGetUrlInformationInitiated()
  ])
}
